<template>
    <div class="d-flex justify-end">
        <SrButton
            v-if="showSubmit"
            :disabled="!canSubmit"
            :loading="loading"
            class="ml-2"
            type="secondary"
            @click="$emit('submit-clicked')"
        >
            Submit
        </SrButton>
    </div>
</template>

<script>
import SrButton from '../../components/SrButton/SrButton';

export default {
    components: { SrButton },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        canSubmit: {
            type: Boolean,
            default: false,
        },
        showSubmit: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
